import { render, staticRenderFns } from "./FileWidget.vue?vue&type=template&id=1ae60ed0&"
import script from "./FileWidget.vue?vue&type=script&lang=js&"
export * from "./FileWidget.vue?vue&type=script&lang=js&"
import style0 from "./FileWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports